<template>
     <div>
        <div class="pop_open ms-2" @click="showModal">
            <div class="info_icon">
                <SvgHeaderSvg :type="'info'" />
            </div>
        </div>
        <CommonCustomModal v-model="flagShowModal" :size="'lg'">
          <div class="diameter">
              <div class="modal-body px-0">
                <div class="diameter-title">
                  <h3 class="mb-0 font-active">Openable Bangle Bracelet Size</h3>
                </div>
                <div class="diameter-body">
                  <div class="table-container">
                    <!-- bangle size -->
                    <div class="dm-table">
                        <div class="d-title">
                          <p>Bangle Size</p>
                        </div>
                        <div class="d-data">
                          <p>inch</p>
                          <p>2.2"</p>
                          <p>2.4"</p>
                          <p>2.6"</p>
                          <p>2.8"</p>
                        </div>
                    </div>

                    <!-- diameter -->
                    <div class="dm-table">
                        <div class="d-title">
                          <p>Diameter</p>
                        </div>
                        <div class="d-data">
                          <p>mm</p>
                          <p>54</p>
                          <p>57.2</p>
                          <p>60.3</p>
                          <p>63.5</p>
                        </div>
                    </div>

                    <!-- circumference -->
                    <div class="dm-table">
                        <div class="d-title">
                          <p>Circumference</p>
                        </div>
                        <div class="d-data">
                          <p>mm</p>
                          <p>158.9</p>
                          <p>168.2</p>
                          <p>177.3</p>
                          <p>186.7</p>
                        </div>
                        <div class="d-data">
                          <p>cm</p>
                          <p>15.89</p>
                          <p>16.82</p>
                          <p>17.73</p>
                          <p>18.67</p>
                        </div>
                        <div class="d-data">
                          <p class=" border-bottom-0">inch</p>
                          <p class=" border-bottom-0">6.25"</p>
                          <p class=" border-bottom-0">6.6"</p>
                          <p class=" border-bottom-0">7"</p>
                          <p class=" border-bottom-0">7.4"</p>
                        </div>
                    </div>
                  </div>
                  <p class="bottom-text">To find your ideal bangle bracelet fit, start by wrapping a thread or a strip of paper around your wrist, making sure it sits comfortably without being too tight. Once you are done with that measure the size on a measuring tape. Take note of the measurement and compare it with the size chart below to find your perfect match. If you prefer a looser, more relaxed fit, consider sizing up for added comfort.
                    Once you've got your size, it's time to get creative! Style and stack your bracelets to create a look that's uniquely yours.</p>
                </div>
              </div>     
          </div>
        </CommonCustomModal>     
      </div>
         
</template>

<script setup>
	const flagShowModal = ref(false)
	function showModal(){
		flagShowModal.value = true
	}
</script>



<style scoped>

.diameter-title{
  margin-bottom: 20px;
}

h3{
  font-size: 20px;
  text-align: left;
}

.table-container{
  width: 100%;
  border: 1px solid #c4c4c4;
  border-radius: 4px;
}

.dm-table{
  display: flex;
  flex-direction: column;
}

.d-title{
  background-color: #668b8419;
  text-align: left;
  padding: 6px 12px;
  font-weight: 600;
}

.d-title p{
  margin: 0;
  color: #353535;
  font-size: 14px;
  text-align: left;
}

.d-data{
  display: flex;
  align-items: center;
}

.d-data p{
  padding: 8px 12px;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  color: #606060;
  border-right: 1px solid #eaeaea;
  border-bottom: 1px solid #eaeaea;

  margin: 0;
  flex: 1;
}

.d-data p:last-child{
  border-right: none;

}

.bottom-text{
  font-size: 14px;
  margin-top: 20px;
  margin-bottom: 0;
  color: #606060;
  line-height: 24px;
}

@media(min-width:768px){
  .d-title p, .d-data p, .bottom-text{
    font-size: 16px;
  }
}
</style>